import React from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';

function UINavbar({ toggleSidebar }) {
  const { pathname } = useLocation();
  const pageLabel = pathname.split('/')[1].replace(/-/g, ' ') || 'home';

  return (
    <nav className="navbar navbar-light bg-flex-pink">
      <div className="container-fluid">
        <span className="navbar-brand mb-0 h1 text-uppercase text-light">
          <span className="me-2" style={{ cursor: 'pointer' }} onClick={toggleSidebar}>
            ☰
          </span>
          {pageLabel}
        </span>
      </div>
    </nav>
  );
}

UINavbar.propTypes = {
  toggleSidebar: PropTypes.func,
};

export default UINavbar;
